import styles from "./Billboard.module.css";
import React from "react";
import imgToken from "../assets/images/st.webp";

function Billboard({
  id,
  uploadedImage,
  onImageUpload,
  duration,
  onDurationChange,
  onDelete,
  costPerMonth,
}) {
  const handleDurationChange = (value) => {
    onDurationChange(Math.max(1, Math.min(72, value)));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file || !file.type.startsWith("image/")) return;

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const MAX_SIZE = 300 * 1024;
      let quality = 0.9;
      const canvas = document.createElement("canvas");

      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      let compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
      while (compressedDataUrl.length * 0.75 > MAX_SIZE && quality > 0.1) {
        quality -= 0.05;
        compressedDataUrl = canvas.toDataURL("image/jpeg", quality);
      }

      if (compressedDataUrl.length * 0.75 > MAX_SIZE) {
        alert(
          "Unable to compress image below 300KB. Please choose a smaller one."
        );
      } else {
        onImageUpload(compressedDataUrl);
      }
    };

    reader.readAsDataURL(file);
  };

  const triggerFileInput = () => {
    document.getElementById(`imageInput-${id}`).click();
  };

  return (
    <div className={styles.billboard}>
      <div className={styles.imageBox}>
        {uploadedImage ? (
          <div className={styles.imagePreviewWrapper}>
            <img src={uploadedImage} alt="Uploaded" />
            <span
              className={styles.removeImageButton}
              onClick={() => onImageUpload(null)}
            >
              x
            </span>
          </div>
        ) : (
          <>
            <div className={styles.imageBoxSpecs}>
              <p>Aim for: 16:9</p>
            </div>
            <button
              className={styles.uploadImageButton}
              onClick={triggerFileInput}
            >
              UPLOAD IMAGE
            </button>
            <input
              id={`imageInput-${id}`}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageUpload}
            />
          </>
        )}
      </div>
      <div className={styles.right}>
        {uploadedImage ? (
          <div className={styles.durationAndTokensDiv}>
            <div className={styles.durationContainer}>
              <h3 className={styles.durationHeading}>
                Duration <span>(months)</span>
              </h3>
              <div className={styles.duration}>
                <button
                  className={styles.durationButtonMinus}
                  onClick={() => handleDurationChange(duration - 1)}
                >
                  -
                </button>
                <input
                  className={styles.durationInput}
                  type="number"
                  value={duration}
                  onChange={(e) => handleDurationChange(Number(e.target.value))}
                  min={1}
                  max={72}
                />
                <button
                  className={styles.durationButtonPlus}
                  onClick={() => handleDurationChange(duration + 1)}
                >
                  +
                </button>
              </div>
            </div>

            <div className={styles.steedieTokens}>
              <img src={imgToken} alt="Steedie Tokens Icon" />
              <div className={styles.tokensText}>{costPerMonth * duration}</div>
            </div>
          </div>
        ) : (
          <p>Upload an image then choose a duration</p>
        )}

        <div className={styles.deleteDiv}>
          <button onClick={onDelete}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default Billboard;
